import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewPageRoutingModule } from './new-page-routing.module';
import { AppJobModule } from '../app-job/app-job.module';

import { NewPageComponent } from './new-page.component';
import { HeaderComponent } from './components/header/header.component';
import { DirectorDeskComponent } from './components/director-desk/director-desk.component';
import { AboutComponent } from './components/about/about.component';
import { FormComponent } from './components/about/form/form.component';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { SpecialsComponent } from './components/specials/specials.component';
import { ToppersComponent } from './components/toppers/toppers.component';
import { AlumniComponent } from './components/alumni/alumni.component';
import { StaffComponent } from './components/staff/staff.component';
import { FacilitiesComponent } from './components/facilities/facilities.component';
import { TemplateComponent } from './components/facilities/template/template.component';
import { SportsComponent } from './components/sports/sports.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { InfraDetailsComponent } from './components/infra-details/infra-details.component';
import { DetailsComponent } from './components/details/details.component';
import { FooterComponent } from './components/footer/footer.component';
import { DisclosureComponent } from './components/disclosure/disclosure.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { DocumentsComponent } from './components/disclosure/documents/documents.component';
import { VisitFormComponent } from './components/about/visit-form/visit-form.component';
import { MatSelectModule } from '@angular/material/select';
// import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
// import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';

// import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
// import {
//   MatLegacyInputModule as MatInputModule,
//   MatLegacyInputModule,
// } from '@angular/material/legacy-input';
// import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
// import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
// import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
// import { MatLegacyNativeDateModule as MatNativeDateModule } from '@angular/material/legacy-core';
import { MatOptionModule } from '@angular/material/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ShareDialogComponent } from './components/share-dialog/share-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { DownloadsComponent } from './components/downloads/downloads.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';

// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
// import { MatButtonModule } from '@angular/material/button';
// import { MatRadioModule } from '@angular/material/radio';

@NgModule({ declarations: [
        NewPageComponent,
        HeaderComponent,
        DirectorDeskComponent,
        AboutComponent,
        FormComponent,
        SpecialsComponent,
        ToppersComponent,
        AlumniComponent,
        StaffComponent,
        FacilitiesComponent,
        TemplateComponent,
        SportsComponent,
        TestimonialsComponent,
        InfraDetailsComponent,
        DetailsComponent,
        FooterComponent,
        DisclosureComponent,
        NotificationsComponent,
        AboutUsComponent,
        DocumentsComponent,
        VisitFormComponent,
        ShareDialogComponent,
        DownloadsComponent,
    ], imports: [CommonModule,
        NewPageRoutingModule,
        FormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatDatepickerModule,
        MatIconModule,
        AppJobModule,
        // MatCardModule,
        MatButtonModule,
        MatDialogModule,
        MatRadioModule,
        MatOptionModule,
        MatNativeDateModule,
        MatSnackBarModule,
        MatCheckboxModule], providers: [
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
            useValue: { appearance: 'outline' },
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class NewPageModule {}
